import { DatePipe } from '@angular/common';
import { Component, input, model } from '@angular/core';
import { FormControl, FormGroupDirective, ValidationErrors } from '@angular/forms';
import { InputNumber } from 'primeng/inputnumber';

@Component({
  selector: 'shared-validation-message',
  templateUrl: './validation-message.component.html',
  styleUrls: ['./validation-message.component.scss'],
  imports: [DatePipe],
  providers: [FormGroupDirective],
})
export class ValidationMessageComponent {
  readonly control = input<FormControl>();
  readonly customError = input(false);

  readonly inputNumber = model<InputNumber | undefined>(undefined);

  protected get errors(): ValidationErrors | null | undefined {
    return this.control()?.errors;
  }

  protected formatValue(value: unknown): string {
    return this.inputNumber() ? String(this.inputNumber().formatValue(Number(value))) : String(value);
  }
}
